import { render, staticRenderFns } from "./RodapeUsuario.vue?vue&type=template&id=dfbee56e&scoped=true&"
import script from "./RodapeUsuario.vue?vue&type=script&lang=js&"
export * from "./RodapeUsuario.vue?vue&type=script&lang=js&"
import style0 from "./RodapeUsuario.vue?vue&type=style&index=0&id=dfbee56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbee56e",
  null
  
)

export default component.exports